// extracted by mini-css-extract-plugin
export default {"wrapper":"delete-modal_wrapper__+qYlA","titleBox":"delete-modal_titleBox__zyCtP","title":"delete-modal_title__L-nne","name":"delete-modal_name__XWx7o"};